var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBackgroundDecoration2 = function SvgBackgroundDecoration2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 620,
    height: 472,
    viewBox: "0 0 620 472",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4314_102720)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 620,
    height: 472,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.581 -149.236C221.234 -153.655 231.019 -151.033 235.437 -143.38L302.174 -27.7882C306.593 -20.1355 303.971 -10.35 296.318 -5.93174L69.8714 124.807C62.2187 129.226 52.4333 126.604 48.015 118.951L-18.7219 3.35911C-23.1402 -4.29357 -20.5182 -14.079 -12.8655 -18.4973L213.581 -149.236Z",
    fill: "url(#paint0_linear_4314_102720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4478 271.815L118.413 368.751C122.694 376.164 120.154 385.644 112.74 389.924L-116.928 522.523C-124.342 526.803 -133.821 524.263 -138.101 516.85L-194.067 419.914C-198.347 412.501 -195.807 403.021 -188.394 398.741L41.2745 266.142C48.688 261.862 58.1676 264.402 62.4478 271.815Z",
    stroke: "#DAD8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.448 -48.1846L799.71 16.3554C803.99 23.769 801.45 33.2486 794.037 37.5288L564.368 170.128C556.955 174.408 547.475 171.868 543.195 164.454L505.933 99.9143C501.653 92.5008 504.193 83.0212 511.606 78.7409L741.274 -53.858C748.688 -58.1382 758.168 -55.5981 762.448 -48.1846Z",
    stroke: "#DAD8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.96 -15.6045C607.613 -20.0228 617.398 -17.4008 621.816 -9.74809L640.924 23.348C645.343 31.0007 642.721 40.7861 635.068 45.2044L559.917 88.5927C552.265 93.0109 542.479 90.3889 538.061 82.7363L518.953 49.6402C514.535 41.9875 517.157 32.202 524.809 27.7838L599.96 -15.6045Z",
    fill: "url(#paint1_linear_4314_102720)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.6973,
    y: 132,
    width: 17.4206,
    height: 66.6236,
    rx: 4,
    transform: "rotate(60 35.6973 132)",
    fill: "#FEB45E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.697,
    y: 402,
    width: 17.4206,
    height: 46.8528,
    rx: 4,
    transform: "rotate(60 565.697 402)",
    fill: "#F86498"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.266,
    y: 30,
    width: 17.4206,
    height: 36.1023,
    rx: 4,
    transform: "rotate(60 112.266 30)",
    fill: "#61D5EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4314_102720",
    x1: 268.806,
    y1: -85.584,
    x2: 14.6465,
    y2: 61.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4314_102720",
    x1: 631.37,
    y1: 6.79995,
    x2: 528.507,
    y2: 66.1882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4314_102720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 620,
    height: 472,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBackgroundDecoration2);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";